import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from "react-router-dom";
import {
  TOP,
  MATCH,
  USERNAME,
  TOKEN,
  TWO_WEEKS_MS,
  EXP_DATE,
  PATHS,
  USER,
} from '../../../utils/constants';
import useLoadingLayer from '../../../utils/hooks/useLoadingLayer';
import useSetError from '../../../utils/hooks/useSetError';
import { AppContext } from '../../../storage/context';
import LoginForm from '../../forms/LoginForm';
import { postLogin } from '../../../api/services/Auth';
import LanguageSelectMenu from '../../common/LanguageSelectMenu';
import Button45 from '../../common/ui/Buttons/Button45';
import './index.scss';

const LoginPage = () => {
  const dispatch = React.useContext(AppContext)[1];

  const intl = useIntl();
  const navigate = useNavigate();
  const loadingLayer = useLoadingLayer();
  const setError = useSetError();

  const localToken = sessionStorage.getItem(TOKEN) || '';

  const setToken = token => {
    dispatch({
      type: 'setToken',
      token,
    });
  };

  const setUser = user => {
    dispatch({
      type: 'setUser',
      user
    });
  };

  const login = async (values, formikBag, isGuest=false) => {
    let loginData = {};

    if (!isGuest) {
      loginData = {
        email: values.email,
        password: values.password,
      };
    }

    try {
      loadingLayer.show();
      const { jwt, user } = await postLogin(loginData, setError, intl, !!isGuest);
  
      if (jwt) {
        setToken(jwt)
        dispatch({ type: 'nullError', error: {} });
        sessionStorage.setItem(TOKEN, jwt);
        const expDate = new Date(Date.now() + TWO_WEEKS_MS).toISOString();
        sessionStorage.setItem(EXP_DATE, expDate);
        sessionStorage.setItem(USERNAME, loginData.name);
        navigate(PATHS.menu);
      }
      if (user) {
        setUser(user);
        sessionStorage.setItem(USER, JSON.stringify(user));
      }
    } catch(error) {
      console.error(error);
    } finally {
      loadingLayer.hide();
    }

    if (!isGuest) {
      formikBag.setSubmitting(false);
    }
  };

  React.useEffect(() => {
    if (localToken) {
      navigate(PATHS.menu);
    }
  }, [navigate, localToken]);

  return (
    <div className="login-page">
      <div className="login-page__container">
        <LanguageSelectMenu
          className="login-page__language-select-menu"
        />
        <h3
          className="login-page__welcome"
          dangerouslySetInnerHTML={{ __html: intl.messages['loginPage.welcome'] }}
        ></h3>
        <div className="login-page__title">
          <h1 className="login-page__title-front">{TOP}</h1>
          <h1 className="login-page__title-back">{MATCH}</h1>
        </div>
        <div className="login-page__descriptions">
          <p
            className="login-page__description"
            dangerouslySetInnerHTML={{ __html: intl.messages['loginPage.description1'] }}
          ></p>
          <p
            className="login-page__description"
            dangerouslySetInnerHTML={{ __html: intl.messages['loginPage.description2'] }}
          ></p>
          <p
            className="login-page__description"
            dangerouslySetInnerHTML={{ __html: intl.messages['loginPage.description3'] }}
          ></p>
        </div>
        <LoginForm onSubmit={login} />
        <p
          className="login-page__forgot-password"
          onClick={() => navigate(PATHS.forgotPassword)}
        >{intl.messages['loginPage.forgotPassword']}</p>
        <p
          className="login-page__resend-verification"
          onClick={() => navigate(PATHS.resendVerifyMail)}
        >{intl.messages['login.resendVerificationMail']}</p>

        <Button45
            className='login-page__button -guest-login -primary-dark'
            label={intl.messages['login.guestLogin']}
            handleClick={() => login(null, null, true)}
            boldLabel={true}
        />
      </div>
    </div>
  );
};

export default LoginPage;
